import LiveUderlyingSpot from './LiveUderlyingSpot';

export default LiveUderlyingSpot;
